export default __webpack_public_path__ + "static/media/no-data.79b05908.jpg";